import { gql } from "@apollo/client";import { useQuery, useLazyQuery } from "@apollo/client/react";import React, { useState, useEffect } from 'react';
import { useForm } from '../../components/hooks/useForm';
import { Grid, Paper, Link } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { GetDescripcionMensaje } from '../../helpers/tools';
import logo from '../../assets/images/logo_nutrihome.png';
import fondo from '../../assets/images/Medicos.jpg';
import ZoomAni from '@mui/material/Zoom';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import toast, { Toaster } from 'react-hot-toast';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import config from '../../config';
import ErrorDialog from './../../components/ErrorDialog';
import { CustomButton } from '../../components/customButton/CustomButton';

function Guid() {
  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const ValidacionPasswordExpReg = config.ValidacionPasswordExpReg;
  const ValidacionPasswordDescripcion = config.ValidacionPasswordDescripcion;
  const ReservedWord = config.ReservedWord;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const guidparam = searchParams.get("clave");
  const cnlparam = searchParams.get("cnl");
  const QGuid = gql`
    query QGuid($clave: String!){
        validateGuid(guid: $clave) {
        valorEsperado,
        success,
        error    
        }          
    }`;

  const [ipClient, setIpClient] = useState('');
  fetch('https://api.ipify.org?format=json').
  then((results) => results.json()).
  then((data) => setIpClient(data.ip)).
  catch((e) => console.log(e));

  const QChange = gql`
    query QChange($claveGuid: String!, $password:String!, $codigo:String!, $ipUsuario: String!, $pcUsuario: String!){
        changePassFromGuid(
            guid: $claveGuid,
            pass: $password,
            codigo: $codigo,
            ipUsuario: $ipUsuario,
            pcUsuario: $pcUsuario) 
        {
            success,
            error,
            valorEsperado {
                valido
              }  
        }          
    }`;

  const [BlanquearPass, { data: dataBlanquearPass, error: errorBlanquearPass }] = useLazyQuery(QChange);

	useEffect(() => {
		if (!dataBlanquearPass) return;
    if (dataBlanquearPass.changePassFromGuid.success) {
      if (dataBlanquearPass.changePassFromGuid.valorEsperado.valido) {
        toast.success("Se cambio la contraseña correctamente");
        navigate("/");
      } else

      toast.error(dataBlanquearPass.changePassFromGuid.error);
    } else
    {
      let descripcionError = GetDescripcionMensaje(dataBlanquearPass.changePassFromGuid.error);
      if (isNaN(descripcionError)) {
        let mensaje = `${dataBlanquearPass.changePassFromGuid.error} - ${descripcionError}`;
        toast.error(mensaje);
      } else
      {
        setMensajeError(dataBlanquearPass.changePassFromGuid.error);
      }
    }
	}, [dataBlanquearPass]);

  useEffect(() => {
    if (!errorBlanquearPass) return;
    setMensajeError("ERRORDB");
  }, [errorBlanquearPass]);  

  const paperStyle = { padding: 20, height: '370px', width: 280, margin: "20px auto", borderRadius: 25 };
  const btnstyle = { margin: '8px 0' };
  const [formValues, formHandle] = useForm({
    password: '',
    passwordRepeat: '',
    clave: '',
    codigo: '',
    ipUsuario: ipClient,
    pcUsuario: ''
  });
  const [state, setState] = useState({
    loading: false,
    error: null
  });
  const isFormValid = () => {
    let validaRegExp = new RegExp(ValidacionPasswordExpReg);
    let listaPalabras = ReservedWord.split('|');

    if (formValues.password.length === 0) {
      toast.error("La contraseña es obligatoria");
      return false;
    }

    if (formValues.passwordRepeat.length === 0) {
      toast.error("El Campo Repetir Contraseña es obligatorio");
      return false;
    }

    if (formValues.codigo.length === 0) {
      toast.error("El Campo Código Verificación es obligatorio");
      return false;
    }

    if (listaPalabras.some(function (valor) {
      let reg = new RegExp(valor);
      let result = reg.test(formValues.password.toUpperCase());
      if (result) {
        toast.error('No debe contener la palabra ' + valor + ' o ' + valor.toLowerCase() + ' ni cualquier derivación.');
        return true;
      }
    })) return false;

    if (!validaRegExp.test(formValues.password)) {
      toast.error('Debe ingresar una contraseña correcta: ' + ValidacionPasswordDescripcion);
      return false;
    }

    if (formValues.passwordRepeat !== formValues.password) {
      toast.error("Las contraseñas no coinciden");
      return false;
    }
    return true;
  };


  const handleKeyCodigo = (event) => {
    if (event.key === 'Enter') {
      handleClick();
    } else if (event.keyCode == 8) {
      formHandle();
    } else {
      const regex = /^[0-9\b]+$/;
      if (!regex.test(parseInt(event.key, 10))) {
        event.preventDefault();
      } else {

        //formHandle();
      }}
  };

  const handleClick = () => {
    if (isFormValid()) {
      console.log(guidparam, formValues.password);
      BlanquearPass({ variables: { claveGuid: guidparam, password: formValues.password, codigo: formValues.codigo, ipUsuario: ipClient, pcUsuario: '' } });
    }
  };
  const handleClickShowPassword = () => {
    setState({
      ...state,
      ShowPass: !state.ShowPass
    });
  };

  const { data: dataGuid, error: errorGuid } = useQuery(QGuid, {
    variables: { clave: guidparam }
  });

	useEffect(() => {
		if (!dataGuid) return;
    if (dataGuid.validateGuid.success && !dataGuid.validateGuid.valorEsperado) {
      toast.error("Guid invalido o expirado");
      navigate('/');
    }
	}, [dataGuid]);  

	useEffect(() => {
		if (!errorGuid) return;
    toast.error("Ocurrio un error al comunicarse con la BD");
    navigate("/");    
	}, [errorGuid]);    

  return (
    <Box
      display="flex"
      alignItems="center"
      style={{
        minHeight: "100vh", backgroundColor: "rgb(210, 210, 210,0.3)",
        backgroundImage: `url(${fondo})`, backgroundRepeat: "no-repeat", backgroundBlendMode: "lighten", backgroundSize: "cover"
      }}
      zIndex="1">
      
            <ZoomAni in>
                <Paper elevation={10} style={paperStyle}>
                    <Grid align='center'>
                        <h3 style={{ color: "rgb(0,114,186)" }}>Cambiar Contraseña</h3>
                        <img src={logo} width='70%'></img>
                    </Grid>
                    <br></br>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-password">Contraseña</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-password"
              name='password'
              label='Contraseña'
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder='Contraseña'
              value={formValues.password}
              onChange={formHandle}
              type={state.ShowPass ? 'text' : 'password'}
              endAdornment={
              <InputAdornment position="end">
                                    <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end">
                  
                                        {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>}
              fullWidth required />
            
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-passwordRepeat">Repita la Contraseña</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-passwordRepeat"
              name='passwordRepeat'
              label='Repita la Contraseña'
              inputProps={{ style: { textAlign: 'center' } }}
              placeholder='Repita la Contraseña'
              value={formValues.passwordRepeat}
              onChange={formHandle}
              type={state.ShowPass ? 'text' : 'password'}
              endAdornment={
              <InputAdornment position="end">
                                    <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  edge="end">
                  
                                        {state.ShowPass ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>}
              fullWidth required />
            
                    </FormControl>
                    <br></br>
                    <br></br>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-user">Código Verificación</InputLabel>
                        <OutlinedInput
              id="outlined-adornment-user"
              name='codigo'
              label='Código Verificación'
              inputProps={{ style: { textAlign: 'center' }, maxLength: 4 }}
              placeholder='Código verificación'
              value={formValues.codigo}
              onChange={formHandle}
              onKeyDown={handleKeyCodigo}
              fullWidth required />
            
                    </FormControl>
                    <CustomButton
            loading={state.loading}
            loadingIndicator="Actualizando Contraseña..."
            style={btnstyle}
            variant="contained"
            onClick={handleClick}
            fullWidth>
                        Cambiar Contraseña
                    </CustomButton>
                    <hr></hr>
                    <Box style={{ marginTop: "20px", textAlign: "right" }} fullWidth>
                        <Link style={{ color: "rgb(0,114,186)" }} href="/">
                            Volver
                        </Link>

                    </Box>
                </Paper>
            </ZoomAni>
            
            <ErrorDialog
        id="dlg-error-guid"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </Box>);


}
export default Guid;